<template>
  <div class="wrapper">
    <div class="printContainer" id="printContainer" ref="printContainer">
      <div class="contentBox">
        <div class="bigFont">{{ recordData.examName }}</div>
        <div class="detailBox">
          <div class="left">
            <div class="title">考生信息</div>
            <div class="detailForm">
              <div class="detailBar">
                姓名：{{ recordData.studentName }}
                <!-- <div class="key">姓名：</div>
                <div class="val">{{ recordData.studentName }}</div> -->
              </div>
              <div class="detailBar">
                性别：{{ recordData.sex }}
                <!-- <div class="key">性别：</div>
                <div class="val">{{ recordData.sex }}</div> -->
              </div>
              <div class="detailBar">
                手机：{{ recordData.mobile }}
                <!-- <div class="key">手机：</div>
                <div class="val">{{ recordData.mobile }}</div> -->
              </div>
              <div class="detailBar">
                身份证：{{ recordData.idCard }}
                <!-- <div class="key"></div>
                <div class="val">{{ recordData.idCard }}</div> -->
              </div>
              <div class="detailBar">
                部门：{{ recordData.deptName }}
                <!-- <div class="key">部门：</div>
                <div class="val">{{ recordData.deptName }}</div> -->
              </div>
              <div class="detailBar">
                职位：{{ recordData.positionName }}
                <!-- <div class="key">职位：</div>
                <div class="val">{{ recordData.positionName }}</div> -->
              </div>
            </div>
          </div>
          <div class="right">
            <img
              :src="recordData.avatar || recordData.faceUrl"
              class="avatar"
            />
          </div>
        </div>
      </div>
      <div class="contentBox">
        <div class="title">成绩信息</div>
        <div class="twoSideBox">
          <div class="cicleContainer">
            <el-progress
              type="circle"
              :percentage="
                parseInt((recordData.getScore * 100) / recordData.totalScore) ||
                0
              "
              :show-text="false"
            ></el-progress>
            <div class="progressFont midFont">{{ recordData.getScore }}分</div>
            <h2 class="centerFont">分数</h2>
          </div>
          <div class="cicleContainer">
            <el-progress
              type="circle"
              :show-text="false"
              :percentage="
                parseInt(
                  (recordData.useTime * 100) / (recordData.totalTime * 60)
                ) || 0
              "
            ></el-progress>
            <div class="progressFont midFont">
              {{
                parseInt(recordData.useTime / 60) +
                "分" +
                (recordData.useTime % 60) +
                "秒"
              }}
            </div>

            <h2 class="centerFont">用时</h2>
          </div>
        </div>
        <div class="twoSideBox" style="background: #f6f6f6; padding: 8px 20px">
          <div class="key">考试总分</div>
          <div class="value">{{ recordData.totalScore }}</div>
        </div>
        <div class="twoSideBox" style="background: #fbe9e7; padding: 8px 20px">
          <div class="key">考试总时长</div>
          <div class="value">{{ recordData.totalTime }}分</div>
        </div>
        <div class="twoSideBox" style="background: #fcf8e3; padding: 8px 20px">
          <div class="key">开始时间</div>
          <div class="value">{{ recordData.startTime }}</div>
        </div>
        <div class="twoSideBox" style="background: #e9f5e9; padding: 8px 20px">
          <div class="key">交卷时间</div>
          <div class="value">{{ recordData.endTime }}</div>
        </div>
        <div class="title">考试总结</div>
        <div class="contentList">
          考试分类试题总结与建议：<br />
          <div style="width: 90%; margin: 10px auto">
            {{ recordData.suggest }}
            <!-- 这次考试中物业员(师)职业能力评价做的不错，高级物业管理师、物业入住与装修管理、Internet应用题型、World文字处理、操作系统基础题型、档案管理、电子表格Excel基础题型、演示文稿PPT基础题型、计算机多媒体基础题型、人力资源、应用文书、系统默认试题、合同、公共秩序管理、招投标、财务管理、承接查验、早期介入与前期管理稍有不足。 -->
          </div>
        </div>
      </div>
      <div class="contentBox">
        <div class="title">试卷考察内容</div>
        <div>
          本次测试为{{
            recordData.examName
          }}，考试覆盖内容以及各个部分的占比如下图：
        </div>
        <div
          class="pieContainer"
          style="margin-left: -30px; height: 400px"
          id="pieContainer"
        >
          <v-chart :option="examContentPie" style="height: 400px"></v-chart>
        </div>
        <div class="title">分类答题情况</div>
        <div class="tableContainer">
          <el-table
            :data="recordData.questionGroupAnalysisDTOList"
            stripe
            style="width: 100%"
          >
            <el-table-column prop="groupName" label="分类" width="180">
            </el-table-column>
            <el-table-column prop="questionNum" label="题目总数">
            </el-table-column>
            <el-table-column prop="correctQuestionNum" label="答对">
            </el-table-column>
            <el-table-column prop="errorQuestionNum" label="答错">
            </el-table-column>
            <el-table-column prop="getScore" label="得分"> </el-table-column>
            <el-table-column prop="correctRate" label="正确率">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="contentBox">
        <div class="title">能力图谱</div>
        <div
          class="pieContainer"
          id="groupScoreRadar"
          style="height: 400px"
          v-if="groupScoreRadar.series[0].data[0].value.length > 2"
        >
          <v-chart :option="groupScoreRadar" style="height: 400px"></v-chart>
        </div>
        <div
          class="detailBox"
          v-for="(value, key) in recordData.groupGetScoreRateMap"
          :key="'score' + key"
        >
          <div style="width: 120px">{{ key }}</div>
          <el-progress
            style="flex: 1"
            :percentage="parseInt(value)"
            :stroke-width="20"
          ></el-progress>
        </div>

        <div class="title">答题记录</div>

        <el-collapse v-model="activeName" accordion ref="qstCollapse">
          <el-collapse-item title="" name="1">
            <template slot="title">
              <div style="width: 300px">
                {{ activeName == 1 ? "收起" : "展开" }}答题记录详情
              </div>
            </template>
            <div class="questionBox">
              <div
                class="questionCell"
                v-for="(qst, qstIdx) in recordData.questionInfoDTOList"
                :key="'question' + qst.id"
              >
                <div class="qstTitle">
                  <span class="blueFont"
                    >{{ qstIdx + 1 }}、[{{ qst.type }}]</span
                  >
                  {{ qst.content | removeTag }}
                </div>
                <div
                  class="aswBar"
                  v-for="asw in qst.answerDTOList"
                  :key="'asw' + asw.id"
                >
                  {{ String.fromCharCode(asw.showNo + 64) }}、
                  {{ asw.content | removeTag }}
                </div>
                <div class="qstConditionBar" v-if="qst.questionTypeId != 4">
                  <div class="myAsw">
                    <div class="aswTitle">
                      考生答案
                      <i
                        :class="[
                          qst.ifCorrect ? 'el-icon-check' : 'el-icon-close',
                          qst.ifCorrect ? 'greenFont' : 'redFont',
                        ]"
                      ></i>
                    </div>

                    <div
                      v-if="
                        qst.questionTypeId == 1 ||
                        qst.questionTypeId == 2 ||
                        qst.questionTypeId == 5
                      "
                    >
                      {{
                        qst.answerDTOList
                          .filter((item) =>
                            qst.studentChooseList.includes(String(item.id))
                          )
                          .map((item) => String.fromCharCode(item.showNo + 64))
                          .join(",")
                      }}
                    </div>
                    <div v-if="qst.questionTypeId == 3">
                      <div v-for="asw in qst.studentChooseList" :key="asw">
                        {{ asw }}
                      </div>
                    </div>
                  </div>
                  <div class="correctAsw" style="width: 200px">
                    正确答案<br />
                    <span
                      v-if="
                        qst.questionTypeId == 1 ||
                        qst.questionTypeId == 2 ||
                        qst.questionTypeId == 5
                      "
                      >{{
                        qst.answerDTOList
                          .filter((item) => item.isCorrect == 1)
                          .map((item) => String.fromCharCode(item.showNo + 64))
                          .join(",")
                      }}</span
                    >
                    <div v-if="qst.questionTypeId == 3">
                      <div
                        v-for="asw in qst.answerDTOList"
                        :key="'asw' + asw.id"
                      >
                        {{ asw.content }}
                      </div>
                    </div>
                  </div>
                  <div class="score" style="width: 200px">
                    分数:<br />
                    <span class="blueFont"
                      >{{ qst.giveScore || 0 + "/" + qst.score }}分</span
                    >
                  </div>
                </div>
                <div class="askQstConditionBar" v-if="qst.questionTypeId == 4">
                  考生答案：
                  <div style="border: 1px solid #ccc; width: 80%; padding: 4px">
                    {{ qst.studentChooseList[0] || "未答" }}
                  </div>
                  <div class="reference">
                    参考答案：
                    <div v-html="qst.consultAnswer"></div>
                  </div>
                  <div class="commentBar">批注：{{ qst.comment }}</div>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div class="title">智能防作弊图片列表</div>
        <div class="antiContainer" v-if="recordData.antiCheatList">
          <div
            class="antiBox"
            v-for="item in recordData.antiCheatList.filter((item) => item.url)"
            :key="'anti' + item.url"
          >
            <el-image fit="contain" class="antiImg" :src="item.url"></el-image>
            <div class="centerFont">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>

    <el-button @click="printContext" class="printBtn" size="big" type="primary">
      打印</el-button
    >
  </div>
</template>

<script>
import { getExamReport } from "@/api/examination/examination.js";
import ECharts from "vue-echarts";

import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, PieChart, RadarChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  PolarComponent,
  TitleComponent,
} from "echarts/components";

use([
  CanvasRenderer,
  BarChart,
  GridComponent,
  TooltipComponent,
  PolarComponent,
  PieChart,
  RadarChart,
  TitleComponent,
]);
import Print from "print-js";
export default {
  data() {
    return {
      recordId: 0,
      questionGroupAnalysisDTOList: [],
      examContentPie: {
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "55%",

            center: ["50%", "60%"],
            data: [],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
      groupGetScoreRateMap: "",
      groupScoreRadar: {
        title: {
          text: "能力图谱",
        },
        radar: {
          // shape: 'circle',
          name: {
            textStyle: {
              color: "#fff",
              backgroundColor: "#999",
              borderRadius: 3,
              padding: [3, 5],
            },
          },
          indicator: [],
        },
        series: [
          {
            name: "能力图谱",
            type: "radar",
            // areaStyle: {normal: {}},
            data: [
              {
                value: [],
              },
            ],
          },
        ],
      },
      recordData: {
        examName: "",
        avatar: "",
        faceUrl: "",
        totalScore: 0,
        totalTime: 0,
        startTime: 0,
        endTime: 0,
      },
      activeName: 0,
      ifShowQuestion: false,
    };
  },
  components: {
    "v-chart": ECharts,
  },
  filters: {
    removeTag(content) {
      return content.replace(/<[^>]+>/g, "");
    },
  },
  created() {},
  mounted() {
    this.recordId = this.$route.query.id;
    getExamReport({ recordId: this.recordId }).then((data) => {
      // 饼图
      for (let key in data.groupRateMap) {
        this.examContentPie.series[0].data.push({
          name: key,
          value: data.groupRateMap[key],
        });
      }
      // 雷达图
      for (const key in data.groupGetScoreRateMap) {
        this.groupScoreRadar.radar.indicator.push({ name: key, max: 100 });
        this.groupScoreRadar.series[0].data[0].value.push(
          data.groupGetScoreRateMap[key]
        );
      }
      this.examContentPie.series[0].width =
        document.getElementsByClassName("pieContainer")[0].offsetWidth + 30;

      Object.assign(this.recordData, data);
    });
  },
  methods: {
    printContext() {
      this.$refs.qstCollapse.setActiveNames("1");

      ["groupScoreRadar", "pieContainer"].forEach((id) => {
        let mycanvas = document
          .getElementById(id)
          .getElementsByTagName("canvas")[0];
        console.log(mycanvas);
        if (mycanvas) {
          let parent = mycanvas.parentElement;
          let image = mycanvas.toDataURL("image/png");
          let img = document.createElement("img");
          img.src = image;
          img.width = mycanvas.width;
          img.height = mycanvas.height;
          parent.appendChild(img);
          parent.removeChild(mycanvas);
        }
      });

      setTimeout(() => {
        Print({
          printable: "printContainer",
          type: "html",
          targetStyles: ["*"],
        });
      }, 2000);
    },
  },
};
</script>
<style scoped lang="less">
@import url("./index.css");
.printBtn {
  position: fixed;
  top: 50%;
  right: 15%;
  // transform: translateX(50%);
  transform: translateY(50%);

  width: 160px;
}
.wrapper {
  .contentBox {
    width: 700px;
    // margin: 30px auto;
    background: #fff;
    padding: 10px;
    .title {
      color: #09c9ac;
      font-size: 18px;
      margin: 10px 0;
    }
    .detailBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .detailForm {
        width: 100%;
      }
      .left {
        flex: 1;
        .detailForm {
          .detailBar {
            width: 50%;
            display: inline-block;
            // justify-content: space-between;
            .key {
              // width: 100px;
              // width: 30%;
              min-width: 60px;
              text-align: right;
              display: inline-block;
            }
            .val {
              flex: 1;
              // width: 70%;
              display: inline-block;
            }
          }
        }
      }
      .right {
        width: 20%;
        min-width: 100px;
        .avatar {
          width: 100%;
          object-fit: contain;
        }
      }
    }
    .detailBox + .detailBox {
      margin-top: 10px;
    }
    .twoSideBox {
      width: 80%;
      margin: auto;
      padding: 8px 20px;
      display: flex;
      justify-content: space-between;
      .key {
        width: 300px;
      }
      .value {
        width: 300px;
        float: right;
        text-align: right;
      }
      .cicleContainer {
        position: relative;
        .progressFont {
          left: 0px;
          top: 0px;
          height: calc(100% - 40px);
          width: 100%;
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .twoSideBox + .twoSideBox {
      margin-bottom: 15px;
    }
    .contentList {
      position: relative;
      width: 90%;
      margin: auto;
      line-height: 24px;
    }
    .contentList::after {
      content: "";
      position: absolute;
      height: 10px;
      width: 10px;
      border-radius: 6px;
      background: orange;
      left: -16px;
      top: 6px;
    }

    .questionBox {
      // min-height: 20vh;
      // max-height: 45vh;
      // overflow: scroll;
      .questionCell {
        border-bottom: 1px solid #ccc;
        padding: 20px 0 0 0;

        .qstTitle {
        }
        .aswBar {
        }
        .qstConditionBar {
          display: flex;
          justify-content: space-between;
          margin: 20px 0;
          .myAsw {
            width: 200px;
            .aswTitle {
              display: flex;
              align-items: center;
              i {
                font-size: 20px;
              }
            }
          }
        }
        .askQstConditionBar {
          margin: 20px 0;
        }
      }
    }
    .antiContainer {
      // width: 90%;
      display: flex;
      justify-content: space-between;

      .antiBox {
        width: 45%;

        .antiImg {
          width: 100%;
          height: 180px;
        }
      }
    }
  }
}
.chart {
  height: 400px;
}
</style>
